<template>
  <div>
    <stock :searchObj="searchObj" :stockTypeObj="stockTypeObj" ref="stock" @postListData="postListData">
      <template v-slot:searchDiv>
        <div class="secondSearchLine">
          <el-date-picker v-model="searchObj.date" value-format="yyyy-MM-dd" style="width:1.5rem" size="mini" type="date" placeholder="选择日期"></el-date-picker>
          <el-select placeholder="请选择" size="mini" style="width: 1.3rem" v-model="searchObj.star">
            <el-option v-for="item in spotOptionsOne" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
          <el-select placeholder="请选择" size="mini" style="width:1.3rem" v-model="searchObj.location">
            <el-option v-for="item in spotOptionsTwo" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
      </template>
      <template v-slot:contentDiv>
        <div v-for="(item,index) in dataList" :key="index">
          <div v-if="item.productType==2">
            <exclusive-stock :keyStr="keyStr" :productObj="item"></exclusive-stock>
          </div>
          <div v-else class="contentDiv">
            <hotel-resource-left :productObj="item" :showTag="false" :btnName="'选择外观'" :btnName1="'询'" 
              class="contentHead" @exclusiveAddYsP="exclusiveAddYsP(item)" @inquiryResource="inquiryResource">
            </hotel-resource-left>
            <div class="contentContainer" v-if="item.isOpen">
              <div class="cardBtn">
                <div v-for="(type,typeIndex) in typeList" :key="typeIndex" :class="item.checkTypeName&&item.checkTypeName==type?'active':''"
                  @click="item.checkTypeName=type">{{type}}</div>
              </div>
              <div class="boxContainer1">
                <div  v-for="(item1, index1) in item.customList" :key="index1">
                  <div v-if="item1.budgetType==item.checkTypeName">
                    <div v-for="(item2,index2) in item1.children" :key="index2">
                      <div class="firstLine">
                        <span class="productName">{{item2.productNameCn}}</span>
                        <div v-if="item2.productId===0">
                          <span style="cursor: pointer;" @click="changePrice(item,item1,item2)">免费</span>
                          <i class="el-icon-circle-plus-outline" @click="addBudget(item,item2)"></i>
                        </div>
                        <div v-else>
                          <label>{{item2.cancelType==1?"不可取消":item2.cancelType==5?"随时退":item2.cancelType==6?"过期退":"有条件退"}}</label>
                          <label class="label" v-for="(item3,index) in item2.labels" :key="index">{{item3}}</label>
                          <svg-icon :iconClass="'arrow-down'" @click="openStockDetail(item2)"></svg-icon>
                          <span style="font-size: 0.18rem;cursor: pointer;text-decoration: underline;" @click="changePrice(item,item1,item2)">{{item2.priceList[0].price}}{{item2.priceList[0].currency}}</span>
                          <label style="font-weight:bold;font-size:0.14rem">{{searchObj.date}}</label>
                          <el-input v-model="item2.checkNumber" style="width: 0.5rem" size="mini"></el-input>
                          <label>&nbsp;{{item2.priceList[0].priceCompany}}</label>
                          <div class="item3">
                            <span class="qiang" >抢</span>
                            <i class="el-icon-circle-plus-outline" @click="addBudget(item,item2)"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <p style="text-align: right">
                <i class="el-icon-caret-top" @click.stop="item.isOpen = false"></i>
              </p>
            </div>
          </div>
        </div>
      </template>
    </stock>
    <create-product-dialog ref="createProduct" :keyStr="keyStr" :searchDate="searchObj.date"></create-product-dialog>
    <stock-detail-dialog ref="stockDetail"></stock-detail-dialog>
  </div>
</template>
<script>
import Stock from './stock.vue'
import hotelResourceLeft from './child/hotelResourceLeft.vue'
import PlanApi from '@/components/Api/PlanApi.js'
import ResourceApi from '@/components/Api/resource.js'
import { refresh } from '../../js/function'
import Api from '@/components/Api/index.js'
import createProductDialog from './addProductDialog/createProductDialog.vue'
import stockDetailDialog from "./addProductDialog/stockDetailDialog.vue"
export default {
  components:{Stock,hotelResourceLeft,createProductDialog,stockDetailDialog},
  data(){
    return{
      searchObj:{
        cityId:null,
        cityName:null,
        cityNameCn:null,
        cityNameEn:null,
        countryId:null,
        date:null,
        star:null,
        location:null,
        searchHotelPrice:null,
        keyword:null,
        productType:0,
        state:2,
      },
      spotOptionsOne: [
        {
          value: "不限人群",
          label: "不限人群",
        },
        {
          value: "必去景点",
          label: "必去景点",
        },
        {
          value: "情侣蜜月",
          label: "情侣蜜月",
        },
        {
          value: "家庭游",
          label: "家庭游",
        },
        {
          value: "亲子游",
          label: "亲子游",
        },
        {
          value: "毕业旅行",
          label: "毕业旅行",
        },
        {
          value: "爸妈游",
          label: "爸妈游",
        },
        {
          value: "商务游",
          label: "商务游",
        },
        {
          value: "游学",
          label: "游学",
        },
      ],
      spotOptionsTwo: [
        {
          value: "不限类型",
          label: "不限类型",
        },
        {
          value: "教堂",
          label: "教堂",
        },
        {
          value: "建筑",
          label: "建筑",
        },
        {
          value: "著名景点观光",
          label: "著名景点观光",
        },
        {
          value: "文化遗迹",
          label: "文化遗迹",
        },
        {
          value: "名胜古迹",
          label: "名胜古迹",
        },
      ],
      dataList:[],
      keyStr:'',
      typeList:['门票','年卡季','特色体验项','门票+项目组']
    }
  },
  props:{
    stockTypeObj:{
      type:Object,
      default:()=>{return {}}
    },
    checkState:{
      type:Number,
      default:0,
    }
  },
  methods:{
    changePrice(item,item1,item2){
      this.$refs.createProduct.beforeOpen(item,item2,this.chenckBudgteObj)
    },
    exclusiveAddYsP(item){
      this.postAddBudget(item,[],7)
    },
    addBudget(item,item1){
      var arr = []
      if(item1.stockId!=0){
        arr.push({
          stockId:item1.stockId,
          stockNumber:item1.checkNumber
        })
      }
      this.postAddBudget(item,arr,item1.stockId===0?8:3)
    },
    inquiryResource(item){
      var obj={
        state:2,
        nameCn:item.nameCn,
        nameId:item.id,
        cityName:item.cityNameCn,
        cityId:item.cityId,
        stayDate:this.searchObj.date
      }
      this.$Bus.$emit('openInquiryPage',obj)
    },
    postAddBudget(item,arr,productType){
      var obj = {
        budgetMainId:this.$store.state.budgetMainId,
        planId:this.$store.state.planId,
        state:2,
        startLinkId:this.searchObj.cityId,
        startLinkName:this.searchObj.cityNameCn,
        startLinkNameEn:this.searchObj.cityNameEn,
        linkType:1,
        stayDate:this.searchObj.date,
        productType:productType,
        resourceId:item.id,
        resourceNameCn:item.nameCn,
        resourceNameEn:item.nameEn,
        key:this.keyStr,
        details:arr
      }
      new PlanApi('plan').budgetAdd(obj).then(res => {
        if (res.status == 200) {
          this.$message({type:"success",message:"添加成功"})
          new ResourceApi('resource').addResourceHot({rid:item.id}).then(res => {})
          refresh(res.data,this.$store.state.planId,this.$store.state.budgetMainId,'refresh')
        }else{
          this.$message({type:"error",message:res.statusText})
        }
      })
    },
    postListData(type){
      if(this.checkState===2){
        if(type=='empty'){
          this.dataList =[]
          this.keyStr=''
        }
        this.searchObj.startDate = this.searchObj.date;
        this.searchObj.endDate = this.searchObj.date;
        this.searchObj.key = this.keyStr;
        if(!this.$refs.stock.isMore){
          new Api('resource').rightStockList({page:this.$refs.stock.page,size:10,q:this.searchObj}).then(res => {
            if (res.status == 200) {
              if(res.data.length<10) this.$refs.stock.isMore = true;
              this.$refs.stock.getDateList(res.data)
              res.data.forEach(element => {
                this.dataList.push(element)
              });
              this.keyStr = res.key
            }else{
              this.$message({type:"error",message:res.statusText})
            }
          })
        }
      } 
    },
    openStockDetail(item){
      this.$refs.stockDetail.openDialog(item,2)
    }
  }
}
</script>

<style lang="scss" scoped>
.secondSearchLine{
  display: flex;
  /deep/ .el-select{
    margin-left: 0.1rem;
    width: 1rem;
  }
}
.contentDiv{
  border-radius: 12px 12px 0 0;
  border: 1px solid #db4e1a;
  padding-top: 0.1rem;
  margin-bottom: 0.07rem;
  .contentContainer{
    .cardBtn{
      display: flex;
      .active{
        color: #fff;
        background: #e3734a;
      }
      >div{
        border-right: 1px solid #e3734a;
        border-bottom: 1px solid #e3734a;
        cursor: pointer;
        flex: 1;
        text-align: center;
        color: #e3734a;
      }
    }
    .boxContainer1{
      padding: 0.1rem;
      font-size: 0.12rem;
      .firstLine{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 0.1rem;
        >div{
          display: flex;
          align-items: center;
          >label{
            margin-right: 0.05rem;
          }
          >span{
            font-size: 0.14rem;
            color: #ca000b;
            font-weight: bold;
            margin:0 0.05rem;
          }
          i{
            font-size: 0.28rem;
          }
        }
        .item3{
          display: flex;
          margin-left: 0.1rem;
          .qiang{
            font-size: 0.18rem;
            box-shadow: 0px 0px 4px 0px #333;
            border-radius: 50%;
            color: red;
            text-align: center;
            display: inline-block;
            width: 0.26rem;
            height: 0.26rem;
            margin-right: 0.05rem;
            line-height: 0.26rem;
            font-weight: bold;
            vertical-align: middle;
          }
          >i{
            font-size: 0.28rem;
          }
        }
      }
      .productName{
        color: #000;
        text-shadow: 2px 2px 3px #888;
        margin-right: 0.1rem;
        width: 2.8rem;
      }
    }
    >p{
      >i{
        font-size: 0.25rem;
      }
    } 
  }
}
</style>